import { AdministrateResourceDeleteButton } from "../../../components/AdministrateResourceDeleteButton";
import { useTableContext } from "../../../components/AdministrateTable";
import { History } from "../../../tools/sandbox/release/History";
import { useDestroyPermission, useUpdatePermission } from "../../../utils";
import { EditOnshoreConfigurationModal } from "./EditOnshoreConfigurationModal";

export const OnshoreConfigurationActionCell = ({ row }) => {
  const { refresh, setMessage, setError } = useTableContext();
  const [canDestroy] = useDestroyPermission("OnshoreConfiguration", row.original.id);
  const [canUpdate] = useUpdatePermission("OnshoreConfiguration", row.original.id);

  return (
    <>
      {canUpdate && (
        <EditOnshoreConfigurationModal
          color="link"
          onshoreConfiguration={row.original}
          onUpdate={() => {
            refresh();
            setMessage(`Updated Onshore Configuration ${row.original.id}.`);
          }}
        />
      )}

      {canDestroy && (
        <AdministrateResourceDeleteButton
          deleteUrl={`/admin/onshore_configurations/${row.original.id}`}
          onSuccess={() => {
            refresh();
            setMessage(`Deleted Onshore Configuration ${row.original.id}.`);
          }}
          onError={setError}
        />
      )}

      <History entityName="OnshoreConfiguration" subjectId={row.original.id} />
    </>
  );
};
